import './Navigation.css';

const NaviButton = (props: any) =>{ 

    return (
        <div className={props.css} onClick={() => {
            props.update(props.thisPage);
        }}>
            {props.name}
        </div>
    );
}

export default NaviButton;